import { useCallback, useEffect, useState } from 'preact/hooks';
import { GameState } from '@/game-state';
import { Button, Checkbox, Input } from '@/ui/components';
import { useClient, useLocale } from '@/ui/context';

export function Login() {
  const client = useClient();
  const { locale } = useLocale();
  const [username, setUsername] = useState(client.authenticationController.getPendingUsername() ?? '');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const [busy, setBusy] = useState(client.loginPending);
  const [loginStatus, setLoginStatus] = useState(client.loginStatus);
  useEffect(() => client.subscribeLoginProgress(() => { setBusy(client.loginPending); setLoginStatus(client.loginStatus); }), [client]);

  useEffect(() => {
    return client.authenticationController.subscribeLoginFailed(() => {
      setPassword('');
    });
  }, [client]);

  const onSubmit = useCallback(
    (e: SubmitEvent) => {
      e.preventDefault();
      if (!client.loginPending) client.authenticationController.login(username, password, rememberMe);
    },
    [username, password, rememberMe, client],
  );

  const cancel = useCallback(() => {
    client.setState(GameState.Connected);
  }, [client]);

  return (
    <div class='card w-full max-w-96 bg-base-100 shadow-sm'>
      <div class='card-body'>
        <div class='card-title'>{locale.login.title}</div>
        <form onSubmit={onSubmit} class='flex flex-col gap-4'>
          <Input
            label={locale.login.username}
            name='username'
            autocomplete='username'
            value={username}
            onChange={(val) => setUsername(val)}
            autofocus
          />
          <Input
            label={locale.login.password}
            name='password'
            autocomplete='current-password'
            value={password}
            type='password'
            onChange={(val) => setPassword(val)}
          />
          <Checkbox
            label={locale.login.remember}
            checked={rememberMe}
            onChange={setRememberMe}
          />
          {busy && <p role='status' class='text-sm'>{loginStatus}</p>}
          <div class='card-actions'>
            <Button type='submit' variant='primary' disabled={busy}>
              {busy ? 'Signing in…' : locale.login.btnConnect}
            </Button>
            <Button variant='ghost' onClick={cancel} disabled={busy}>
              {locale.shared.btnCancel}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
